import { currentPage } from '../common/layout';
import {
  commentsCountUpdate,
  loadCommentsNumber,
  disableAdsInEmbedVideo,
  initCoralComments,
  coralCommentsEdition,
  initCoralByCommentsBtnEditions,
  checkAndFilterCoralCommentsAmountToShow,
  setupScrollOnClick,
  getAdfeed,
  getCookie,
  setCookie,
} from '../common/utils/fn';
import { getStroeerGalleryBanners } from '../common/utils/adv-stroeer-mobile-gallery-loader';
import { getFaqWidget } from '../common/widgets/widget-faq-loader';
import { getCompareImages } from '../common/widgets/widget-compare-images-loader';
import { getPointsOfInterest } from '../common/widgets/widget-points-of-interest-loader';
import 'jquery-mousewheel';
// import '../common/lightgallery/jquery-lightgallery';
// import '../common/lightgallery/jquery-lightgallery-aside';
// import '../common/lightgallery/jquery-lightgallery-additional';
// import '../common/lightgallery/jquery-lightgallery-topside';
// import '../common/lightgallery/jquery-lightgallery-custom-content';
// import '../common/msnt/msnt-lightslider.js';
// import '../common/lightzoom';
// import 'jquery-scrolltie';
// import { cmpBubbles } from '../common/cmp-bubbles';
// import { msntPhotoThumbGallery } from '../common/msnt/msnt-loader';
import { getNewsletterWidget } from '../common/widgets/widget-newsletter-loader';
import { loadDisqusComments } from '../common/jquery-lazy-load-3rd-party';
import { getStickyVideo } from '../common/utils/sticky-video-loader';
// import { getPlayVideoEmbed } from '../common/utils/playVideoEmbed-loader';
import { topComments } from '../common/top-comments';
// import '../common/jquery-lazy-load-3rd-party';
// import '../common/modernizr';
// import '../common/player';
// import '../common/lazyload.picture';
// import '../common/lot-linx-car';
// import { renderEbay } from '../common/widgets/widget-ebay';
// import { throttle, debounce } from 'throttle-debounce';
import device from 'current-device';

import { msntConsent } from '../../../core/prioritized/consent/msnt-consent';
// import '../common/scroll-depth';

currentPage.pageInit = ($page, pageData, pageId) => {
  const dataEdtn = document.body.dataset.edtn;
  // const urlGetParam = window.location.search;
  // const isAutoPlay = urlGetParam == '?autoplayEmbed' ? true : false;

  var $window = $(window),
    $body = $(document.body),
    $page = $('#' + pageId),
    $recommendedBox = $page.find('.recommendedBox'),
    $pageIsRtl = $('body').data('rtl');
    var isVideoArticle = document.querySelector('.videowrapper');
    let cpUserIsLogged = $body.hasClass('cpauthenticated');
    // cpass
    const $contentpassEditions = ['fr', 'ar', 'us', 'it', 'me', 'es', 'tr', 'id'];
    var cpAuthhint = document.cookie.includes('_cpauthhint=1');
    let isDevEnv = document.body.classList.contains('development');
    // const contentPassCountries = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'CH', 'GB', 'UA'];

  import(/* webpackPrefetch: true */ '../common/scroll-depth')
    .then(module => {
      module.trackSectionScrollDepth($('article'));
  })

  // cpass
  if (!cpAuthhint) {
    disableAdsInEmbedVideo();
  }

  checkAndFilterCoralCommentsAmountToShow();
// cpass

if (!cpAuthhint) {
  topComments.init({
    config: { active: 1 },
  });
}

  msntConsent.initEmbeds($('.postBody'));
  // cpass
  if (cpAuthhint) {
    msntConsent.initEmbedVideo($('.root'));
  }

const shareData = {
  title: document.getElementsByClassName('main-article-heading')[0].textContent,
  text: document.getElementsByClassName('sub-article-heading')[0].textContent,
  url: document.location.href,
};

let shareButton = document.getElementsByClassName('m1-article-meta_share')[0];
// console.log(shareButton, window.device.type);
if (shareButton !== null) {
  shareButton.addEventListener("click", async () => {
    if (window.device.type !== 'desktop') {
      gtmDataLayer.push({
        event: 'socialButtonClicked',
      });
      try {
        await navigator.share(shareData);
      } catch (err) {
        console.log(err);
      }
    }
  });
}

  window.addEventListener('message', function(e){
    let data = e.data;
    if (data === 'newComment') {
      gtmDataLayer.push({
        event: data,
      });
    }
  })

  // scrollingToComments();
  let pointsOfInterestWidget = document.querySelector('[data-widget="points-of-interest"]');
  if (pointsOfInterestWidget) {
    getPointsOfInterest().then((api) => {
      api.pointsOfInterest();
    });
  }

  let compareImagesWrapper = document.querySelector('[data-widget="compare-images"]');
  if (compareImagesWrapper) {
    getCompareImages().then((api) => {
      api.compareImages();
    });
  }

  let faqWidget = document.querySelector('.widget_faq');
  if (faqWidget) {
    getFaqWidget().then((api) => {
      api.faqAccordeon();
    });
  }

  let newsLetterWidget = document.querySelector('.widget-newsletter');
  if (newsLetterWidget) {
    getNewsletterWidget().then((api) => {
      api.newsletter();
    });
  }

  let facebookWrapper = document.getElementsByClassName('facebook-video-wrapper')[0];

  if (facebookWrapper) {
    (
      () => {
        let fbSizer = facebookWrapper.querySelector('.sizer');
        let videoIframe = facebookWrapper.querySelector('iframe');

        let fbSizerHeight = fbSizer.offsetHeight;
        let videoIframeWidth = videoIframe.getAttribute('width');
        let videoIframeHeight = videoIframe.getAttribute('height');
        let iframeAspectRatio = videoIframeHeight / videoIframeWidth;
        
        if (iframeAspectRatio === 1) {
          videoIframe.height = fbSizerHeight;
          videoIframe.width = fbSizerHeight;
        } else if (iframeAspectRatio === 0.5625) {
          facebookWrapper.classList.add('facebook-iframe-sizer');
        } else if (iframeAspectRatio > 1) {
          videoIframe.height = fbSizerHeight;
          videoIframe.width = fbSizerHeight / iframeAspectRatio;
        } else {
          videoIframe.height = fbSizerHeight;
          facebookWrapper.classList.add('facebook-iframe-sizer');
        }
      }
    )(); 
  }

  if (isVideoArticle != null) {
    getStickyVideo().then((api) => {
      api.stickyVideo(dataEdtn, false);
    });
  }

  // let collectedVideoEmbeds = document.querySelectorAll('.videoplayer');
  // if (collectedVideoEmbeds.length > 0) {
  //   getPlayVideoEmbed().then((api) => {
  //     api.playVideoEmbed(collectedVideoEmbeds);
  //   });
  // }

  if (dataEdtn == 'de' || dataEdtn == 'ev_de' && !cpAuthhint) {
    getStroeerGalleryBanners().then((api) => {
      api.initDeMobileGalleryBanners();
    });
  }

  let lightzoomWidget = document.querySelector('.lightzoom');
  if (lightzoomWidget && device.type !== 'mobile') {
    import(/* webpackPrefetch: true */ '../common/lightzoom-loader')
    .then(module => {
      module.initializeLightzoom();
    })
  } else if (lightzoomWidget && device.type == 'mobile') {
    let lightzoomWidgets = document.querySelectorAll('.lightzoom');
    for (let lightzoomWidgetItem of lightzoomWidgets) {
      lightzoomWidgetItem.addEventListener('click', (e) => {
        e.preventDefault();
        return;
      })
    }
  }

  import(/* webpackPrefetch: true */ '../common/msnt/msnt-photo-thumb-gallery')
    .then(module => {
      module.msntPhotoThumbGallery();
  })

  //cpass
  if (dataEdtn == 'br') {
    commentsCountUpdate();
    loadDisqusComments();
  }

  //bannerLazyload();
  // if (!coralCommentsEdition.includes($dataEdtn)) loadCommentsNumber();
  if (!coralCommentsEdition.includes(dataEdtn) && !cpAuthhint) loadCommentsNumber();
  const coralContainer = $('#coral_thread');
  const innerCoralContainer = coralContainer.find('#coral-shadow-container');
  const showCoralCommentsBtn = document.querySelector('#show-disqus');
  // const showCoralCommentsBtnTopComments = document.querySelector('.m1-top-comments__empty > span');
  const topCommentsEmptyBlock = document.querySelector('.m1-top-comments');

  if (coralCommentsEdition.includes(dataEdtn) && initCoralByCommentsBtnEditions.includes(dataEdtn) && coralContainer.length) {
    let coralCommentsLoaded = false;
    showCoralCommentsBtn.addEventListener('click', (e) => {
      e.preventDefault();
      initCoralComments();
      coralCommentsLoaded = true;
      if (showCoralCommentsBtn && topCommentsEmptyBlock) {
        showCoralCommentsBtn.remove();
        topCommentsEmptyBlock.remove();
      }
    });

    if(['ra_us', 'ev_us', 'us'].includes(dataEdtn)) {
      const counterSelector = document.querySelector('.coral-count')
      const onReady = () => {
        if (!counterSelector) return;
        const bottomAnchorSelector = document.querySelector('.m1-article-meta_comments-bottom');
        const m1CoralCommentAmount = parseInt(counterSelector.getAttribute('data-coral-count'), 10);
        if(isNaN(m1CoralCommentAmount) && coralCommentsLoaded) return;
        const hasCount = Number.isFinite(m1CoralCommentAmount);
        const isEmpty = hasCount && m1CoralCommentAmount === 0;
        const isSingle = hasCount && m1CoralCommentAmount === 1;
        const isMany = hasCount && m1CoralCommentAmount > 1;

        if((isEmpty && !coralCommentsLoaded)) {
          const anchorSelectors = document.querySelectorAll('.m1-article-meta_comments');
          showCoralCommentsBtn.remove();
          bottomAnchorSelector.querySelector('.top-counter-comments-label').textContent = i18n.comment_js;

          setupScrollOnClick('.m1-article-meta_comments', '#coral_thread');

          anchorSelectors.forEach((anchor) => {
              anchor.addEventListener('click', (e) => {
                if(coralCommentsLoaded) return;
                e.preventDefault();
                initCoralComments();
                topCommentsEmptyBlock.remove();
                coralCommentsLoaded = true;
            })
          })
        } else if(isSingle) {
          bottomAnchorSelector.querySelector('.top-counter-comments-label').textContent = 'Go to comment';
          showCoralCommentsBtn.querySelector('.coral-coment-button-text').textContent = 'Comment';
        } else if(isMany) {
          bottomAnchorSelector.querySelector('.top-counter-comments-label').textContent = `Go to comments`;
        } else {
          setupScrollOnClick('.m1-article-meta_comments', '#comments');
        }
      }

      const mo = new MutationObserver((mutations) => {
        for (const m of mutations) {
          if (m.type === 'attributes' && m.attributeName === 'data-coral-count') {
            onReady();
          }
        }
      });

      mo.observe(counterSelector, { attributes: true, attributeFilter: ['data-coral-count'] });
      onReady();
    } else {
      setupScrollOnClick('.m1-article-meta_comments', '#comments');
    }

    // if (showCoralCommentsBtnTopComments) {
    //   showCoralCommentsBtnTopComments.addEventListener('click', () => {
    //     initCoralComments();
    //     showCoralCommentsBtn.remove();
    //     topCommentsEmptyBlock.remove();
    //   });
    // }
  } else if (coralCommentsEdition.includes(dataEdtn) && coralContainer.length && innerCoralContainer.length) {
    let coralCommentsLoaded = true;
    initCoralComments();
    setupScrollOnClick('.m1-article-meta_comments', '#comments');
  } else {
    setupScrollOnClick('.m1-article-meta_comments', '#comments');
  }
  $('.photo-title a').on('click', function(e) {
    e.stopPropagation();
  });  

  if(dataEdtn === 'de' || dataEdtn === 'ev_de') {
    const trendingWrapper = document.querySelector('.trending-content');
    const outbrainWrapper = document.querySelector('.outbrain_service');
    if(!!trendingWrapper && !!outbrainWrapper && window.innerWidth <= 1023) {
      const parentElement = outbrainWrapper.parentNode;
      parentElement.insertAdjacentElement('afterend', trendingWrapper);
    }
  }
  
  if (dataEdtn != 'de' && dataEdtn != 'ev_de' && !cpAuthhint && device.type == 'desktop') {
    function setSidebarTopPosition() {
      const trendingWidget = document.querySelector('.trending-content');
      const scrollSidebar = document.querySelector('.m1-newsfeed_sidebar-wrapper');
      const bodyTag = document.querySelector('body');
      
      let trendingWidgetHeight;
      if (trendingWidget) {
        trendingWidgetHeight = trendingWidget.offsetHeight;
      }
      
      let headerHeight = 221;
      const contentBeforeHeight = 638;
    
      if (bodyTag.classList.contains('no-rect-strip')) {
        headerHeight = 83;
      }
    
      const paddingNum = (trendingWidgetHeight + contentBeforeHeight) - headerHeight;
    
      if (scrollSidebar) {
        scrollSidebar.style.top = `-${paddingNum}px`;
      }
    }

    let resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        setSidebarTopPosition();
      }, 300);
    });
    setSidebarTopPosition();
  }

  const trendingItems = $('.trending-content_item:visible');

  trendingItems.each((index, item) => {
    $(item)
      .find('.item-index')
      .text(index + 1);
  });

  function setAdfeedData() {
    const articleTag = document.querySelector('.adfeed-container');
    const articleTopicId = articleTag ? articleTag.dataset.topicId : null;
    
    const m1ItUrls = articleTopicId == '506' ? ['/more-news/insideevs/'] : ['/more-news/insideevs/', '/more-news/omnifurgone/'];
    const evFrUrls = articleTopicId == '512' ? [ null ] : ['/more-news/insideevs/'];

    const adFeedConfigs = [
      {
        edtn: 'ra_us',
        urls: ['/more-news/motor1/', '/more-news/insideevs/'],
      },
      {
        edtn: 'us',
        urls: ['/more-news/insideevs/', '/more-news/rideapart/'],
      },
      {
        edtn: 'ev_us',
        urls: ['/more-news/motor1/', '/more-news/rideapart/'],
      },
      {
        edtn: 'it',
        urls: m1ItUrls,
      }, 
      {
        edtn: 'ev_it',
        urls: ['/more-news/motor1/', '/more-news/omnifurgone/'],
      },
      {
        edtn: 'ot',
        urls: ['/more-news/motor1/', '/more-news/insideevs/'],
      },
      {
        edtn: 'fr',
        urls: evFrUrls,
      },
      {
        edtn: 'es',
        urls: ['/more-news/motorsport/', '/more-news/motos/'],
      },
      {
        edtn: 'tr',
        urls: ['/more-news/insideevs/', '/more-news/motorsport/'],
      },
      {
        edtn: 'ev_tr',
        urls: ['/more-news/motor1/', '/more-news/motorsport/'],
      },
      {
        edtn: 'br',
        urls: ['/more-news/insideevs/', '/more-news/motos/'],
      },
      {
        edtn: 'ev_br',
        urls: ['/more-news/motor1/', '/more-news/motos/'],
      },
    ];

    const config = adFeedConfigs.find((cfg) => cfg.edtn === dataEdtn);

    if (!config) return;

    const intersectingTarget = document.querySelector('.adfeed-container');

    if (intersectingTarget) {
      const intersectingOptions = {
        rootMargin: '100px'
      }

      const observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('no-observe');
            observer.unobserve(intersectingTarget);
            const [url1, url2] = config.urls;
            getAdfeed(url1, url2, intersectingTarget);
          }
        }
      }, intersectingOptions);

      observer.observe(intersectingTarget);
    }
  };

  if (device.type == 'desktop') {
    let trendingItems = document.querySelectorAll('#article_box .related-item');
    for (let trendingItem of trendingItems) {
      let imgHeight = trendingItem.querySelector('.related-item-img').offsetHeight;
      let textHeight = trendingItem.querySelector('.title-related-item').offsetHeight;
      // console.log(trendingItem, imgHeight, textHeight, textHeight/imgHeight);
      if (textHeight/imgHeight > 1.62) {
        trendingItem.parentElement.classList.add('oneline');
      }
    }
  }

  setAdfeedData();

  const preferredSourceButton = document.getElementById('preferred-source-button');
   if (preferredSourceButton) {
     preferredSourceButton.addEventListener('click', () => {
      gtmDataLayer.push({
        event: 'googlePreferredSourcesButtonClicked',
        url: document.location.href,
      });
     });
   }


  document.querySelectorAll('.infobox--subheadline').forEach(el => {
    if (!el.textContent.trim()) {
      el.setAttribute('data-empty', 'true');
    }
  });

  const visited = getCookie('visited');
  if (!visited) {
    const initObserver = () => {
      const surveyWidget = document.querySelector('.m1-survey-promo');
      if (!surveyWidget) return false;

      surveyWidget.classList.add('hidden');

      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'class'
          ) {
            if (!surveyWidget.classList.contains('hidden')) {
              surveyWidget.classList.add('hidden');
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(surveyWidget, {
        attributes: true,
        attributeFilter: ['class'],
      });

      return true;
    };

    if (!initObserver()) {
      window.addEventListener('load', () => {
        initObserver();
      });
    }

    setCookie('visited', 1, 3650);
  }
};